<template>
  <div class="combobox-sale-display">
    <div class="flex flex-col">
      <ComboboxSaleItemInfo
        :item="item.saleItem"
        :unit-price="item.unitPrice"
        :project="item.project"
        :has-custom-unit-price="item.hasCustomUnitPrice"
      />
      <div v-if="!item.date" class="text-error font-medium">Geen verkoopdatum geselecteerd!</div>
      <div v-else-if="!item.date.isSame(instruction.date)" class="text-xs">
        {{ item.date.format("DD-MM-YYYY") }}
      </div>

      <!-- Surcharge description -->
      <div v-if="item.surchargeDescription" class="text-xs">
        {{ item.surchargeDescription }}
      </div>

      <!-- Information about surcharge that applies to this sale (consolidated view) -->
      <ConsolidatedSurchargesDisplay :original-transaction="item" :transaction-id="item.id!" />

      <!-- Comment -->
      <div v-if="item.comment" class="text-xs">
        <FontAwesomeIcon :icon="['fas', 'comment']" size="sm" />
        {{ item.comment }}
      </div>

      <div v-if="!item.project" class="text-error font-medium">Geen project geselecteerd!</div>
      <div v-else-if="item.project.id !== instruction.project?.id" class="text-warning">
        {{ item.project?.getDisplayText() }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Sale } from "@/models/sale.model"
import ComboboxSaleItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxSaleItemInfo.vue"
import { inject, type Ref } from "vue"
import type { Instruction } from "@/models/instruction.model"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import ConsolidatedSurchargesDisplay from "@/components/administration/combobox-display-templates/nested/ConsolidatedSurchargesDisplay.vue"

defineProps<{
  item: Sale
}>()

const instruction: Ref<Instruction> = inject("instruction")!
</script>

<style scoped></style>
